import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { BaseDialog } from '@/components/common/BaseDialog';
import { ModalIndices } from '@/common/i-doc/i-doc.registry.ts';
import { CreateTemplateDto } from '@/types/questionnaire-construction';

interface TemplateFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (dto: CreateTemplateDto) => Promise<void>;
}

function emptyForm(): CreateTemplateDto {
  return { nestNameI18n: { uk: '' }, nestDescriptionI18n: { uk: '' } };
}

export const TemplateFormDialog: React.FC<TemplateFormDialogProps> = ({ open, onClose, onSave }) => {
  const [form, setForm] = useState<CreateTemplateDto>(emptyForm());
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm(emptyForm());
  }, [open]);

  const isValid = (form.nestNameI18n?.uk ?? '').trim().length > 0;

  const handleSave = async () => {
    if (!isValid) return;
    setSaving(true);
    try {
      await onSave(form);
    } finally {
      setSaving(false);
    }
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Новий опитувальник"
      maxWidth="sm"
      iDoc={ModalIndices.QUIZ_BUILDER_TEMPLATE_FORM}
      actions={
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!isValid || saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {saving ? 'Створення...' : 'Створити'}
        </Button>
      }
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Назва опитувальника"
          value={form.nestNameI18n?.uk ?? ''}
          onChange={(e) => setForm(f => ({ ...f, nestNameI18n: { uk: e.target.value } }))}
          fullWidth
          autoFocus
        />
        <TextField
          label="Опис"
          value={form.nestDescriptionI18n?.uk ?? ''}
          onChange={(e) => setForm(f => ({ ...f, nestDescriptionI18n: { uk: e.target.value } }))}
          fullWidth
          multiline
          minRows={2}
        />
      </Box>
    </BaseDialog>
  );
};
